import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Brands from "./pages/Brands";
import Team from "./pages/Team";
import Partner from "./pages/Partner";
import Press from "./pages/Press";
import Locations from "./pages/Locations";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <div className="min-h-screen flex flex-col">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/brands" element={<Brands />} />
              <Route path="/team" element={<Team />} />
              <Route path="/partner" element={<Partner />} />
              <Route path="/press" element={<Press />} />
              <Route path="/locations" element={<Locations />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;